import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/components/sidebar';
import { Topbar } from '@/components/topbar';
import { MobileNavDrawer } from '@/components/mobile-nav-drawer';
import { CommandPalette } from '@/components/command-palette';
import { TooltipProvider } from '@/components/ui/tooltip';

export function AppShell(): JSX.Element {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={300}>
      {/* Skip-to-content: visually hidden until focused (keyboard a11y). */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-md"
      >
        Ignorer la navigation
      </a>
      <div className="flex h-screen bg-background text-foreground">
        <Sidebar />
        <MobileNavDrawer open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Topbar
            onOpenCommandPalette={() => setPaletteOpen(true)}
            onOpenMobileNav={() => setMobileNavOpen(true)}
          />
          {/* Page content padding lives here: pages render as `flex flex-col
              gap-*` with no padding of their own, so the scroll container must
              inset them from the topbar + window edges. */}
          <main id="main" className="flex-1 overflow-y-auto p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
        <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
        {/* Polite live region for toast / WS-driven announcements (a11y). */}
        <div aria-live="polite" aria-atomic="true" className="sr-only" data-testid="a11y-live" />
      </div>
    </TooltipProvider>
  );
}

export default AppShell;
